import { Subject } from 'rxjs'
import apiResponse from '../../../../../../services/apiResponse'
import ApproveRepository from '../Repositories/ApproveRepository'


class ApproveBloc {

    approveChannel = new Subject();
    detailChannel = new Subject();
    repository = new ApproveRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.approveChannel.next({status: apiResponse.INITIAL})
    }

    fetchDetail = async (query) => {
        try {
            this.detailChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchDetail(query).then((result) => {
                this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.detailChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }

    fetchApprove = async (query) => {
        try {
            this.approveChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchApprove(query).then((result) => {
                this.approveChannel.next({status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.approveChannel.next({status: apiResponse.ERROR, data: error})
            })
        } catch (error) {console.log("rxjs", "Channel unsubscribed")}
    }
}

export default ApproveBloc